import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=68905d08&scoped=true&"
var script = {}
import style0 from "./Banner.vue?vue&type=style&index=0&id=68905d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68905d08",
  null
  
)

export default component.exports